import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import messages from './OffCanvas.lang.js';
export var Closer = /*#__PURE__*/function (_PureComponent) {
  _inherits(Closer, _PureComponent);

  var _super = _createSuper(Closer);

  function Closer(props) {
    var _this;

    _classCallCheck(this, Closer);

    _this = _super.call(this, props);

    _this.handleHoverToggle = function () {
      _this.setState({
        hover: !_this.state.hover
      });
    };

    _this.state = {
      hover: false
    };
    return _this;
  }

  _createClass(Closer, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          styles = _this$props.styles,
          formatMessage = _this$props.intl.formatMessage;
      var icon = this.props.icon;
      return React.createElement("span", {
        className: classNames(styles.root, icon, (_classNames = {}, _defineProperty(_classNames, styles['has-customIcon'], icon), _defineProperty(_classNames, styles['is-hover'], this.state.hover), _classNames)),
        onClick: this.props.onClick,
        onMouseEnter: this.handleHoverToggle,
        onMouseLeave: this.handleHoverToggle,
        "aria-label": formatMessage(messages.closeBtnAriaLabel)
      });
    }
  }]);

  return Closer;
}(PureComponent);
Closer.defaultProps = {
  icon: 'icon-close',
  styles: {}
};
export default injectIntl(applyStylingHoc({})(Closer));